import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { WEBSITE_ARTICLES } from './websiteData';
import { InsightDocumentIllustration } from './WebsiteIllustrations';

export default function WebsiteArticlePage() {
  const { slug } = useParams();
  const article = WEBSITE_ARTICLES.find((item) => item.slug === slug);

  if (!article) {
    return (
      <div className="dgw-page">
        <section className="dgw-section">
          <div className="dgw-section-header">
            <h2>Article not found</h2>
            <p>The requested public knowledge article does not exist yet.</p>
          </div>
          <div className="dgw-actions">
            <Link className="dgw-btn dgw-btn-primary" to="/website/knowledge">Back to knowledge hub</Link>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="dgw-page">
      <section className="dgw-hero">
        <div className="dgw-hero-main">
          <span className="dgw-pill">{article.category}</span>
          <h1>{article.title}</h1>
          <p className="dgw-lead">{article.summary}</p>
        </div>
        <aside className="dgw-panel">
          <InsightDocumentIllustration />
          <p className="dgw-illustration-caption">
            Each article should feel like a structured insight asset, not just a block of website copy.
          </p>
        </aside>
      </section>

      <section className="dgw-section">
        <div className="dgw-reading-width">
          <p className="dgw-lead">{article.intro}</p>
          {article.sections.map((section) => (
            <div key={section.title} className="dgw-article-section">
              <h2>{section.title}</h2>
              <p>{section.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="dgw-cta-band">
        <div>
          <h2>Next step</h2>
          <p>Use the article flow to move visitors into product evaluation or deeper reading.</p>
        </div>
        <div className="dgw-actions">
          <Link className="dgw-btn dgw-btn-primary" to={article.cta.to}>{article.cta.label}</Link>
          <Link className="dgw-btn dgw-btn-soft" to="/website/knowledge">Knowledge hub</Link>
        </div>
      </section>
    </div>
  );
}
